import React from "react";
import { Icon } from "semantic-ui-react";

const getColor = (acts) => {
	if (acts.includes("SPERM")) return "#15bccf";
	if (acts.includes("PREL")) return "#048B9A";
	if (acts.includes("QCOV")) return "#8B9A04";
	return "grey";
};
const customEvent = ({ start, acts, patientName, qrCode, folder }) => (
	<div className="event" style={{ fontSize: "0.8rem", backgroundColor: getColor(acts), color: "white", margin: "1px" }}>
		<div>
			<span style={{ fontSize: "0.8rem" }}>{start.format("mm") !== "00" ? start.format("HH:mm") : start.format("H").concat("h")}</span> -{" "}
			<b>{acts}</b> : {qrCode && <Icon name="attach" />} {patientName} {folder && <Icon name="file" />}
		</div>
	</div>
);

export default customEvent;
